import './style.scss';
import 'ShopUiBundle/components/atoms/form-check-group';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('payment-shipment-list', () => import(/* webpackMode: "lazy" */'./payment-shipment-list'));
